import type { NotificationDatabaseEntity } from "@/entities/notification-database";

import { useAtomValue, useSetAtom } from "jotai";

import {
  addToOptimisticListAtom,
  notificationOptimisticReadListAtom,
  removeFromOptimisticListAtom,
} from "./notification-optimistic-read.state";

export const useIsNotificationOptimisticRead = (
  notifId: NotificationDatabaseEntity["id"]
) => {
  const list = useAtomValue(notificationOptimisticReadListAtom);

  return list.includes(notifId);
};

export const useNotificationOptimisticRead = () => {
  const activateOptimisticRead = useSetAtom(addToOptimisticListAtom);
  const removeOptimisticRead = useSetAtom(removeFromOptimisticListAtom);

  return {
    activateOptimisticRead,
    removeOptimisticRead,
  };
};
